(function () {
  const dataEl = document.getElementById('solitaire-shape-videos');
  if (!dataEl) return;

  let videoMap = {};
  try {
    videoMap = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Solitaire shape video JSON parse error', e);
    return;
  }

  // Modal ek hi baar banao
  const modal = document.createElement('div');
  modal.className = 'shape-video-modal';
  modal.innerHTML = `
    <div class="shape-video-modal__overlay"></div>
    <div class="shape-video-modal__content">
      <button class="shape-video-modal__close" aria-label="Close">&times;</button>
      <video class="shape-video-modal__video" controls playsinline></video>
    </div>
  `;
  document.body.appendChild(modal);

  const videoEl = modal.querySelector('.shape-video-modal__video');

  function closeModal() {
    modal.classList.remove('is-open');
    videoEl.pause();
    videoEl.removeAttribute('src');
  }

  modal.querySelector('.shape-video-modal__close').addEventListener('click', closeModal);
  modal.querySelector('.shape-video-modal__overlay').addEventListener('click', closeModal);

  function openModal(shapeName) {
    const src = videoMap[shapeName];
    if (!src) return;
    videoEl.src = src;
    modal.classList.add('is-open');
    videoEl.play();
  }

  function addViewLinks() {
    document.querySelectorAll('.gpo-swatches.image-swatches').forEach(function (swatch) {
      const input = swatch.querySelector('input[type="radio"]');
      if (!input) return;

      const shapeName = input.value;
      if (!videoMap[shapeName]) return;
      if (swatch.querySelector('.shape-view-link')) return;

      const viewLink = document.createElement('a');
      viewLink.href = '#';
      viewLink.className = 'shape-view-link';
      viewLink.textContent = 'VIEW';
      viewLink.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(shapeName);
      });

      swatch.appendChild(viewLink);
    });
  }

  // Turant try karo (agar pehle se render ho chuka ho)
  addViewLinks();

  // Aur DOM changes pe nazar rakho (GPO app jab swatches inject kare)
  const observer = new MutationObserver(function () {
    addViewLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();




// Swatch inputs se sabhi valid color values nikalo (Yellow Gold, White Gold, Rose Gold)
// document.addEventListener('DOMContentLoaded', function () {
//   if (!document.body.classList.contains('template-ring-builder')) return;

//   // Swatch inputs se sabhi valid color values nikalo (Yellow Gold, White Gold, Rose Gold)
//   function getValidColorValues() {
//     var inputs = document.querySelectorAll('input[data-field-name="metal-colour"]');
//     var values = [];
//     inputs.forEach(function (input) {
//       var v = (input.value || '').trim().toLowerCase();
//       if (v && values.indexOf(v) === -1) values.push(v);
//     });
//     return values;
//   }

//   function filterImagesByAlt(selectedValue) {
//     if (!selectedValue) return;
//     selectedValue = selectedValue.trim().toLowerCase();

//     var validColors = getValidColorValues();
//     var sliderEl = document.querySelector('.primgSlider');
//     if (!sliderEl) return;

//     var slides = sliderEl.querySelectorAll('a[data-slide]');
//     var firstVisibleId = null;

//     // Decide karta hai ki image hide honi chahiye ya nahi
//     function shouldHide(alt) {
//       alt = (alt || '').trim().toLowerCase();

//       // Case 1: alt empty hai -> kabhi hide mat karo
//       if (alt === '') return false;

//       // Check karo alt kisi valid (known) color se match karta hai kya
//       var matchedKnownColor = null;
//       for (var i = 0; i < validColors.length; i++) {
//         if (alt.indexOf(validColors[i]) !== -1) {
//           matchedKnownColor = validColors[i];
//           break;
//         }
//       }

//       // Case 2: alt koi bhi valid/known color se match nahi karta (invalid alt) -> kabhi hide mat karo
//       if (!matchedKnownColor) return false;

//       // Case 3: alt ek valid color hai; selected se match na ho to hide karo
//       return matchedKnownColor !== selectedValue;
//     }

//     slides.forEach(function (slideLink) {
//       var img = slideLink.querySelector('img');
//       var alt = img ? img.getAttribute('alt') : '';

//       if (shouldHide(alt)) {
//         slideLink.classList.add('metal-color-hidden');
//       } else {
//         slideLink.classList.remove('metal-color-hidden');
//         if (!firstVisibleId) firstVisibleId = slideLink.getAttribute('data-id');
//       }
//     });

//     // Thumbnails sync
//     document.querySelectorAll('.pr_thumbs_item').forEach(function (thumbItem) {
//       var img = thumbItem.querySelector('img');
//       var alt = img ? img.getAttribute('alt') : '';

//       if (shouldHide(alt)) {
//         thumbItem.classList.add('metal-color-hidden');
//       } else {
//         thumbItem.classList.remove('metal-color-hidden');
//       }
//     });

//     // media-gallery ka data-target update — featured/main image force set karta hai
//     var galleryEl = document.querySelector('media-gallery');
//     if (galleryEl && firstVisibleId) {
//       galleryEl.setAttribute('data-target', firstVisibleId);
//     }

//     // Sirf resize — reloadCells/select use nahi karna (crash karta hai)
//     try {
//       var flkty = window.Flickity ? Flickity.data(sliderEl) : null;
//       if (flkty && typeof flkty.resize === 'function') {
//         flkty.resize();
//       }
//     } catch (e) {
//       // ignore
//     }
//   }

//   // Radio input ka normal change event
//   document.addEventListener('change', function (e) {
//     if (e.target && e.target.matches('input[data-field-name="metal-colour"]')) {
//       filterImagesByAlt(e.target.value);
//     }
//   });

//   // Label click bhi catch karo (safety ke liye)
//   document.addEventListener('click', function (e) {
//     var label = e.target.closest('[data-element-id="image-swatches-1"] label[for]');
//     if (label) {
//       var input = document.getElementById(label.getAttribute('for'));
//       if (input) {
//         setTimeout(function () { filterImagesByAlt(input.value); }, 50);
//       }
//     }
//   });

//   // Page load pe default-checked ke hisaab se filter kar do
//   setTimeout(function () {
//     var checkedInput = document.querySelector('input[data-field-name="metal-colour"]:checked');
//     if (checkedInput) filterImagesByAlt(checkedInput.value);
//   }, 800);
// });



document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-ring-builder')) return;

  function getSelectedValue(fieldName) {
    var input = document.querySelector(
      'input[data-field-name="' + fieldName + '"]:checked'
    );

    return input ? input.value.trim() : '';
  }

  function filterImages() {

    var metalColour = getSelectedValue('metal-colour');
    var shopByStyle = getSelectedValue('shop-by-style');
    var solitaireShape = getSelectedValue('solitaire-shape');

    // Teeno values select hone ke baad hi filter kare
    if (!metalColour || !shopByStyle || !solitaireShape) return;

    // Expected ALT:
    // Yellow Gold | Solitaire | Round
    var selectedAlt =
      metalColour + ' | ' +
      shopByStyle + ' | ' +
      solitaireShape;

    selectedAlt = selectedAlt.toLowerCase().trim();

    var sliderEl = document.querySelector('.primgSlider');

    if (!sliderEl) return;

    var slides = sliderEl.querySelectorAll('a[data-slide]');
    var firstVisibleId = null;

    slides.forEach(function (slideLink) {

      var img = slideLink.querySelector('img');

      if (!img) return;

      var alt = (img.getAttribute('alt') || '')
        .trim()
        .toLowerCase();

      /*
       * EXACT ALT MATCH
       *
       * Selected:
       * Yellow Gold
       * Solitaire
       * Round
       *
       * Image:
       * alt="Yellow Gold | Solitaire | Round"
       *
       * => SHOW
       *
       * Image:
       * alt="Yellow Gold | Solitaire | Oval"
       *
       * => HIDE
       */

      if (alt === selectedAlt) {

        slideLink.classList.remove('metal-color-hidden');

        if (!firstVisibleId) {
          firstVisibleId = slideLink.getAttribute('data-id');
        }

      } else {

        slideLink.classList.add('metal-color-hidden');

      }
    });


    // Thumbnails ko bhi same ALT ke according filter karo
    document.querySelectorAll('.pr_thumbs_item').forEach(function (thumbItem) {

      var img = thumbItem.querySelector('img');

      if (!img) return;

      var alt = (img.getAttribute('alt') || '')
        .trim()
        .toLowerCase();

      if (alt === selectedAlt) {
        thumbItem.classList.remove('metal-color-hidden');
      } else {
        thumbItem.classList.add('metal-color-hidden');
      }

    });


    // Main / featured image update
    var galleryEl = document.querySelector('media-gallery');

    if (galleryEl && firstVisibleId) {
      galleryEl.setAttribute('data-target', firstVisibleId);
    }


    // Flickity resize
    try {

      var flkty = window.Flickity
        ? Flickity.data(sliderEl)
        : null;

      if (
        flkty &&
        typeof flkty.resize === 'function'
      ) {
        flkty.resize();
      }

    } catch (e) {
      // ignore
    }
  }


  /*
   * Metal Colour change
   * Shop By Style change
   * Solitaire Shape change
   */
  document.addEventListener('change', function (e) {

    if (
      e.target &&
      (
        e.target.matches('input[data-field-name="metal-colour"]') ||
        e.target.matches('input[data-field-name="shop-by-style"]') ||
        e.target.matches('input[data-field-name="solitaire-shape"]')
      )
    ) {

      // Thoda delay taaki checked state update ho jaye
      setTimeout(function () {
        filterImages();
      }, 50);

    }

  });


  /*
   * Swatch label click
   */
  document.addEventListener('click', function (e) {

    var label = e.target.closest(
      '[data-element-id="image-swatches-1"] label[for], ' +
      '[data-element-id="image-swatches-2"] label[for], ' +
      '[data-element-id="image-swatches-3"] label[for]'
    );

    if (label) {

      setTimeout(function () {
        filterImages();
      }, 100);

    }

  });


  /*
   * Page load par default selected values
   */
  setTimeout(function () {
    filterImages();
  }, 800);

});








document.addEventListener('DOMContentLoaded', function () {

  function updateStoreContent() {

    // 1. Stock Availability → Visit At Store
    document.querySelectorAll('.location-pickup-link').forEach(function (link) {
      if (link.textContent.trim() === 'Stock Availability') {
        link.textContent = 'Check in Store';
      }
    });

    // 2. Loading locations... → Visit At Store
    const locationContainer = document.getElementById('locationNamesContainer');

    if (
      locationContainer &&
      locationContainer.textContent.trim() === 'Loading locations...'
    ) {
      locationContainer.textContent = 'Check in Store';
    }

    // 3. Remove separator before Out of stock
    document.querySelectorAll('label.not-fullfilment').forEach(function (label) {

      const outOfStock = label.querySelector('.ml-stock-msg.ml-out');

      if (!outOfStock) return;

      Array.from(label.childNodes).forEach(function (node) {

        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.includes('-')
        ) {
          // Only remove separator between location and stock status
          node.textContent = node.textContent.replace(/^\s*-\s*$/, ' ');
        }

      });

    });

  }

  // Run immediately
  updateStoreContent();

  // Handle dynamically loaded Shopify app content
  const observer = new MutationObserver(function () {
    updateStoreContent();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

});







document.addEventListener('DOMContentLoaded', function () {

  function updateLocationPhone() {
    document.querySelectorAll('.location-phone a[href^="tel:"]')
      .forEach(function (link) {

        // Keep the original phone number in href
        const phoneNumber = link.getAttribute('href');

        if (!phoneNumber || link.dataset.callUpdated === 'true') {
          return;
        }

        link.textContent = 'Call Store';
        link.setAttribute('aria-label', 'Call Store' + phoneNumber.replace('tel:', ''));
        link.dataset.callUpdated = 'true';
      });
  }

  // Initial update
  updateLocationPhone();

  // Handle dynamically loaded app content
  const observer = new MutationObserver(function () {
    updateLocationPhone();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});



document.addEventListener('DOMContentLoaded', function () {

  function addViewMoreButton() {
    document.querySelectorAll('.custom_drawer__wrapper').forEach(function(drawer) {

      const content = drawer.querySelector('.custom_drawer__content');

      if (!content) return;

      // Prevent duplicate buttons
      if (drawer.querySelector('.custom-drawer-view-more')) return;

      const button = document.createElement('a');

      button.href = 'https://lukson.co/pages/store-locator';
      button.className = 'custom-drawer-view-more';
      button.textContent = 'View More';

      // Add button after drawer content
      content.insertAdjacentElement('afterend', button);

    });
  }

  addViewMoreButton();

  // Support dynamically loaded drawer
  const observer = new MutationObserver(function() {
    addViewMoreButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});